import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { UnstyledButton, Group, Text, rem, Menu } from '@mantine/core';
import {
  IconChevronDown,
  IconCreditCard,
  IconLogout,
  IconUsers,
  IconShieldCheck,
  IconFileText,
  IconPencil,
} from '@tabler/icons-react';
import { AuthContext } from '@contexts/auth-context';
import classes from './user-name-button.module.css';

function UserButton() {
  const navigate = useNavigate();
  const { user, signOut, isUserInGroup } = useContext(AuthContext);
  const isAdmin = isUserInGroup('admin');

  const logout = () => {
    signOut();
    navigate('/');
  };

  return (
    <Menu width={220} shadow="md">
      <Menu.Target>
        <UnstyledButton className={classes.user}>
          <Group gap="xs" preventGrowOverflow wrap="nowrap">
            <Text size="md" fw={600}>
              {typeof user?.name === 'string' ? user.name : user?.email}
            </Text>
            <IconChevronDown style={{ width: rem(14), height: rem(14) }} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown className={classes.menuDropdown}>
        {/* TODO <Menu.Item>Change Password</Menu.Item> */}

        <Menu.Item
          leftSection={<IconCreditCard size={16} />}
          className={classes.menuItem}
          onClick={() => navigate('/billing')}
        >
          Manage Subscription
        </Menu.Item>
        <Menu.Divider />

        {isAdmin && (
          <>
            <Menu.Label>Administration</Menu.Label>
            <Menu.Item
              leftSection={<IconUsers size={16} />}
              className={classes.menuItem}
              onClick={() => navigate('/admin/users')}
            >
              User Administration
            </Menu.Item>
            <Menu.Item
              leftSection={<IconPencil size={16} />}
              className={classes.menuItem}
              onClick={() => navigate('/admin/prompts')}
            >
              Prompt Management
            </Menu.Item>

            <Menu.Divider />
          </>
        )}

        <Menu.Label>Legal</Menu.Label>
        <Menu.Item
          leftSection={<IconShieldCheck size={16} />}
          className={classes.menuItem}
          onClick={() => navigate('/privacy')}
        >
          Privacy Policy
        </Menu.Item>
        <Menu.Item
          leftSection={<IconFileText size={16} />}
          className={classes.menuItem}
          onClick={() => navigate('/terms')}
        >
          Terms of Use
        </Menu.Item>
        <Menu.Divider />

        <Menu.Item leftSection={<IconLogout size={16} />} className={classes.menuItem} onClick={() => logout()}>
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default UserButton;
